export { default } from './spacer'
export { filterSpacingProps } from './utils'
export type { Props as SpacerProps } from './spacer'
